import React from 'react';
import { Card } from 'Common/components/Atoms/Card';
import { Div } from 'Common/components/Atoms/Div';
import { Col } from 'Common/components/Atoms/Flex';
import { Text } from 'Common/components/Atoms/Text';
import { useTheme } from '@mui/material/styles';

interface Props {
  imageHref: string;
  quote: string;
  founder: string;
  title: React.ReactNode;
}

export const Testimonial = ({ imageHref, quote, founder, title }: Props) => {
  const theme = useTheme();

  return (
    <Card
      m={1}
      display="flex"
      justifyContent="center"
      alignItems="center"
      width={540}
      height={230}
      px={4}
    >
      <img
        alt={founder}
        src={imageHref}
        style={{
          width: 140,
          height: 140,
          borderRadius: `${theme.shape.borderRadius}px`,
          objectFit: 'cover',
        }}
      />
      <Col ml={2}>
        <Text
          variant="body1"
          width={354}
          color="textPrimary"
        >{`"${quote}"`}</Text>
        <Text variant="body1" mt={1} color="textPrimary">
          {founder}
        </Text>
        <Div>{title}</Div>
      </Col>
    </Card>
  );
};
